





























































import firebase from 'firebase/app'
import 'firebase/firestore'
import { user } from '../fire.coffee'
import rounder from '../rounder.js'
import moment from 'moment'

export default
    data: ->
        present: []
        notpresent: []
    mounted: ->
        auth = firebase.auth()
        auth.onAuthStateChanged (u) =>
            if user.admin then this.fetch()
    methods:
        moment: moment
        fetch: ->
            id = this.$route.params.event
            firebase.firestore().collectionGroup('tickets')\
            .where('event_id', '==', id)\
            .where('paid', '==', true)\
            .onSnapshot (snap) =>
                tickets = []
                snap.forEach (doc) ->
                    ticket = doc.data()
                    ticket.id = doc.id
                    tickets.push ticket
                tickets.sort (a, b) ->
                    if a.user.last_name > b.user.last_name then 1
                    else if a.user.last_name < b.user.last_name then -1
                    else 0
                this.present = this.userArray(tickets.filter (t) -> t.read?)
                this.notpresent = this.userArray(tickets.filter (t) -> t.read == undefined)
        userArray: (tickets) ->
            result = []
            for ticket in tickets
                oba = (result.filter (x) -> x.user.id == ticket.user.id)[0]
                object = oba ? {tickets: []}
                object.user = ticket.user
                object.tickets.push
                    id: ticket.id
                    pass: ticket.pass
                    customer_id: ticket.customer_id
                    total: ticket.total
                    read: ticket.read
                result.push object unless oba?
            return result
        readText: (ticket) ->
